<template>
    <div class="container">
        <div v-if="false" class="nav">
            <img src="../assets/logo-onon.png" alt="公司logo图片">
            <div class="test-tip">
                语音合成
                <span>测试版</span>
            </div>
        </div>

        <div class="content-cantainer">
            <Button type="primary" shape="circle" icon="md-close" id="close-btn" v-if="contentMsg != ''" @click="delContent"></Button>
            <span class="content-limit">
                <p :class="contentLimit > 3000 ? 'contentLimit-count' : ''">{{contentLimit}}</p>
                 / 3000 字符
            </span>
            <div ref="contentDiv" class="content mgl onon" 
            :class="font == 1 ? 'galt' : ''" contenteditable="true" 
            @input="contentChange" @paste="clip" @compositionend="handleCompositionEnd"
             placeholder="  ：      2017                                 "></div>
            <!-- 语音合成时的loading -->
            <div class="loader-container" v-if="contentMsgPlayLoading">
                <div class="loader">
                    <svg viewBox="0 0 80 80">
                        <circle r="32" cy="40" cx="40" id="test"></circle>
                        <text x="50%" y="60%" text-anchor="middle" fill="#6c35de" font-size="34" font-weight="bold">
                            o
                        </text>
                    </svg>
                </div>
                <div class="loader">
                    <svg viewBox="0 0 80 80">
                        <rect height="64" width="64" y="8" x="8"></rect>
                        <text x="50%" y="60%" text-anchor="middle" fill="#6c35de" font-size="34" font-weight="bold">
                            n
                        </text>
                    </svg>
                </div>
                <div class="loader">
                    <svg viewBox="0 0 80 80">
                        <circle r="32" cy="40" cx="40" id="test"></circle>
                        <text x="50%" y="60%" text-anchor="middle" fill="#6c35de" font-size="34" font-weight="bold">
                            o
                        </text>
                    </svg>
                </div>
                <div class="loader">
                    <svg viewBox="0 0 80 80">
                        <rect height="64" width="64" y="8" x="8"></rect>
                        <text x="50%" y="60%" text-anchor="middle" fill="#6c35de" font-size="34" font-weight="bold">
                            n
                        </text>
                    </svg>
                </div>
            </div>

        </div>
        <div class="play">
            <div class="play-btn">
                <Button :loading="contentMsgPlayLoading" id="tts-btn" type="primary" shape="circle" icon="logo-buffer" v-debounce="contentMsgPlay">
                    <span v-if="!contentMsgPlayLoading">
                        立即合成
                    </span>
                    <span v-else>语音合成中...</span>
                </Button>
                <div class="ws-control">
                    <Button :disabled="contentMsgPlayLoading" type="primary" shape="circle" @click="playPause">
                        <span v-if="isPlaying">
                            <Icon type="md-arrow-dropright-circle" />
                            播放
                        </span>
                        <span v-else>
                            <Icon type="md-pause" />
                            暂停
                        </span>
                    </Button>
                    <Button :disabled="contentMsgPlayLoading" type="primary" shape="circle" icon="md-refresh" @click="replay">重播</Button>
                    <Button :disabled="contentMsgPlayLoading" type="primary" shape="circle" icon="md-download" @click="downloadAudio">下载</Button>
                </div>
            </div>

            <!-- 音频容器 -->
            <div id="waveform">
                <span class="example" v-if="exampleText">合成音频示例</span>
                <span class="duration">{{ currentTime }} / {{ durationTime }}</span>
            </div>

        </div>

        <modalComponent :state="messageModal.state" :code="messageModal.code" :message="messageModal.message"  @cancel="resetModal"></modalComponent>

    </div>
</template>

<script>
    import axios from 'axios';
    import WaveSurfer from 'wavesurfer.js'
    import Hover from 'wavesurfer.js/dist/plugins/hover.esm.js'
    import { mapGetters } from 'vuex';
    import modalComponent from '@/components/modal';
    export default {
        name: 'HelloWorld',
        components:  {
            modalComponent
        },
        data() {
            return {
                contentMsg: '',
                font: 0,
                contentMsgPlayLoading: false,
                exampleText: true,
                contentLimit: 0,//字符数
                // wavesurfer 相关配置
                wavesurfer: null,
                wav: require('@/assets/wav/example-audio.wav'),
                isPlaying: true,
                durationTime: '0:00',
                currentTime: '0:00',

                hasHandled: false,
                messageModal: {
                    state: false,
                    code: 40001,
                    message: 'test'
                }
            };
        },
        computed: {
            ...mapGetters(['isLoggedIn','isNewUser','getUserInfo','userToken','isFree']),
        },
        methods: {
            delContent() {
                this.$refs.contentDiv.innerText = '';
                this.contentMsg = '';
                this.contentLimit = 0;
                this.hasHandled = false
            },
            resetModal() {
                this.messageModal =  {
                    state: false,
                    code: 40001,
                    message: 'test'
                }
            },
            setMessage(code,message) {
                this.messageModal = {
                    state: true,
                    code: code,
                    message: message
                }
            },
            clip(event){
                event.preventDefault();
                let text = event.clipboardData.getData('text');
                document.execCommand('insertText', false, text);
            },
            contentChange(event) {
                this.contentMsg = event.target.innerText;
                this.contentLimit = this.contentMsg.length;
                // console.log(event);

                // 蒙古文输入监听
                // let mo = /[\u1800-\u18AF]/;
                var mo = /[\u1820-\u1842\u180A\u180E\u202F\uE234-\uE34F]/u;
                let isMongolianText = mo.test(event.data);
                if(isMongolianText) {
                    if (!event.isComposing && !this.hasHandled) {
                        // console.log('input mongolian text');
                        this.getFormCodeType();
                        this.hasHandled = true
                    }
                }

            },
            // 中文输入法监听
            handleCompositionEnd() {
            //     if (!this.hasHandled) {
            //         console.log('输入法输入结束')
            //         this.getFormCodeType();
            //         this.hasHandled= true
            //     }
            },
            // 编码判断
            getFormCodeType() {
                let from = new FormData();
                from.append('str', this.contentMsg);
                axios.post(this.$config.CodeApiBaseUrl + 
                '/api/Conversion/FormCodeType',from).then((res) => {
                    if (res.data.Success == 1 && res.data.Result == '民委共享工程标准') {
                        this.font = 1;
                    } else if (res.data.Success == 1 && res.data.Result == '标准') {
                        this.font = 2;
                    } else {
                        this.font = 0;
                    }
                })
                .catch(function (error) {
                    this.$Message.error('接口错误,错误信息为:',error);
                });
            },
            // 语音合成
            contentMsgPlay() {
                if (this.contentMsg == '') {
                    this.$Message.info('请输入合成内容');
                    return;
                }
                if(this.contentLimit > 3000){
                    this.$Message.info('请输入少于3000个字符');
                    return;
                }
                this.contentMsgPlayLoading = true;
                
                this.tokenRequest();

                // if(this.isLoggedIn) {
                //     this.tokenRequest();
                // } else {
                //     this.noTokenRequest();
                // }
            },
            noTokenRequest () {
                if(!this.isFree) {
                    // console.log('not free');
                    this.setMessage(40001,'您的免费次数已用完，请登录后继续使用。');
                    this.contentMsgPlayLoading = false;
                    return;
                }
                axios.post(
                    this.$config.ttsApiBaseUrl,
                    {"content" : this.contentMsg},
                    {headers: { token: this.userToken }}
                ).then(response => {
                    if (response.data.success) {
                        this.wav = this.$config.debugMode?  
                        response.data.data.audioUrl.replace('https://ttsaudio.onon.cn:12504', '/res') : 
                        response.data.data.audioUrl;
                    
                        this.initWaveSurfer();
                        this.contentMsgPlayLoading = false;
                        this.$store.dispatch('setTimes');
                        this.$store.state.isRequest = true;

                    }else{
                        if (response.data.message === null) {
                            this.$Message.error('接口出错');
                        } else {
                            this.$Message.error(response.data.message);
                        }
                        this.contentMsgPlayLoading = false;
                    }
                }).catch(error => {
                    this.$Message.error('接口错误,错误信息为:',error);
                    this.contentMsgPlayLoading = false;
                });
            },
            tokenRequest () {
                // if(!this.isLoggedIn) {
                //     this.contentMsgPlayLoading = false;
                //     this.setMessage(40001,'');
                // }
                // axios.post('http://tts.onon.cn/api/tts?token=', {"content" : this.contentMsg}).then(response => {
                // axios.post('http://11.0.0.168:57471/api/tts?token=', {"content" : this.contentMsg}).then(response => {
                // axios.post('/tts' + 'tts',  {"content" : this.contentMsg}).then(response => {
                // 
                // '/newapi',
                axios.post(
                    this.$config.ttsApiBaseUrl + '/biz/api/tts-service',
                    
                    {"content" : this.contentMsg},
                    {headers: { token: this.userToken }}
                ).then(response => {
                    // console.log(response);
                    if (response.data.success) {
                        this.wav = this.$config.debugMode ?  
                        response.data.result.audioUrl.replace('https://ttsaudio.onon.cn:12504', '/res') : 
                        response.data.result.audioUrl;

                        this.initWaveSurfer();
                        this.contentMsgPlayLoading = false;
                        this.$store.state.isRequest = true;
                    } else {
                        
                        this.setMessage(response.data.code,response.data.message);

                        if (response.data.message === null) {
                            this.$Message.error('接口出错');
                        } else {
                            // this.$Message.error(response.data.message);
                        }
                        this.contentMsgPlayLoading = false;
                    }
                }).catch(error => {
                    this.$Message.error('接口错误,错误信息为:',error);
                    this.contentMsgPlayLoading = false;
                });
            },
            initFirstWaveSurfer() {
                this.exampleText = true
                const options = {
                    container: '#waveform',
                    // height: 50,
                    splitChannels: false,
                    normalize: false,
                    waveColor: '#fff',
                    progressColor: '#000',
                    cursorColor: '#ddd5e9',
                    cursorWidth: 2,
                    barWidth: 3,
                    barGap: 6,
                    barRadius: 10,
                    barHeight: 2,
                    barAlign: 'center',
                    minPxPerSec: .1,
                    fillParent: true,
                    mediaControls: false,
                    autoplay: false,
                    interact: true,
                    dragToSeek: false,
                    hideScrollbar: false,
                    audioRate: 1,
                    autoScroll: true,
                    autoCenter: true,
                    sampleRate: 8000,
                    backend: 'MediaElement',
                    forceDecode: true,
                    plugins: [
                        Hover.create({
                            lineColor: '#ddd5e9',
                            lineWidth: 2,
                            labelBackground: '#6c35de',
                            labelColor: '#fff',
                            labelSize: '11px',
                        }),
                    ],
                }
                this.wavesurfer = WaveSurfer.create(options)
                this.wavesurfer.load(this.wav)
                this.isPlayingFun()
                this.wavesurfer.on('ready', () => {
                    const durationTimeInSeconds = parseInt(this.wavesurfer.getDuration());
                    const minutes = Math.floor(durationTimeInSeconds / 60);
                    const seconds = durationTimeInSeconds % 60;
                    this.durationTime = `${minutes}:${seconds < 10? '0' + seconds : seconds}`;
                    
                })
                this.wavesurfer.on('audioprocess', () => {
                    const currentTimeInSeconds = parseInt(this.wavesurfer.getCurrentTime());
                    const minutes = Math.floor(currentTimeInSeconds / 60);
                    const seconds = currentTimeInSeconds % 60;
                    this.currentTime = `${minutes}:${seconds < 10? '0' + seconds : seconds}`;
                })
                this.wavesurfer.on('interaction', () => {
                    this.wavesurfer.play()
                    this.isPlayingFun()
                })
                this.wavesurfer.on("finish", () => {
                    this.isPlayingFun()
                });
            },
            initWaveSurfer() {
                this.exampleText = false
                if (this.wavesurfer) {
                    this.wavesurfer.destroy();
                }
                const options = {
                    container: '#waveform',
                    splitChannels: false,
                    normalize: false,
                    waveColor: '#fff',
                    progressColor: '#000',
                    cursorColor: '#ddd5e9',
                    cursorWidth: 2,
                    barWidth: 3,
                    barGap: 6,
                    barRadius: 10,
                    barHeight: 2,
                    barAlign: 'center',
                    minPxPerSec: .1,
                    fillParent: true,
                    mediaControls: false,
                    autoplay: false,
                    interact: true,
                    dragToSeek: false,
                    hideScrollbar: false,
                    audioRate: 1,
                    autoScroll: true,
                    autoCenter: true,
                    sampleRate: 8000,
                    backend: 'MediaElement',
                    forceDecode: true,
                    plugins: [
                        Hover.create({
                            lineColor: '#ddd5e9',
                            lineWidth: 2,
                            labelBackground: '#6c35de',
                            labelColor: '#fff',
                            labelSize: '11px',
                        }),
                    ],
                }
                this.wavesurfer = WaveSurfer.create(options)
                this.wavesurfer.load(this.wav)
                this.wavesurfer.play()
                this.isPlayingFun()
                this.wavesurfer.on('ready', () => {
                    const durationTimeInSeconds = parseInt(this.wavesurfer.getDuration());
                    const minutes = Math.floor(durationTimeInSeconds / 60);
                    const seconds = durationTimeInSeconds % 60;
                    this.durationTime = `${minutes}:${seconds < 10? '0' + seconds : seconds}`;
                    
                })
                this.wavesurfer.on('audioprocess', () => {
                    const currentTimeInSeconds = parseInt(this.wavesurfer.getCurrentTime());
                    const minutes = Math.floor(currentTimeInSeconds / 60);
                    const seconds = currentTimeInSeconds % 60;
                    this.currentTime = `${minutes}:${seconds < 10? '0' + seconds : seconds}`;
                })
                this.wavesurfer.on('interaction', () => {
                    this.wavesurfer.play()
                    this.isPlayingFun()
                })
                this.wavesurfer.on("finish", () => {
                    this.isPlayingFun()
                });
            },
            playPause() {
                this.wavesurfer.playPause()
                this.isPlayingFun()
            },
            replay() {
                this.wavesurfer.stop()
                this.wavesurfer.play()
                this.isPlayingFun()
            },
            // downloadAudio() {
            //     const link = document.createElement('a');
            //     link.href = this.wav;
            //     link.download = 'audio.wav';
            //     document.body.appendChild(link);
            //     link.click();
            //     document.body.removeChild(link);
            // },
            async downloadAudio() {
                try {
                    const response = await fetch(this.wav);
                    const blob = await response.blob();

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'onon-tts-audio.wav'); // 自定义下载文件名
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                } catch (error) {
                    console.error('下载失败:', error);
                }
            },
            isPlayingFun() {
                if(this.wavesurfer.isPlaying()){
                    this.isPlaying = false
                }else{
                    this.isPlaying = true
                }
            }
        },
        mounted() {
            this.initFirstWaveSurfer();
            document.addEventListener('DOMContentLoaded', function () {
                let wrapper = document.querySelector('.content');
                wrapper.addEventListener('wheel', function (event) {
                event.preventDefault();
                let scrollLeft = this.scrollLeft;
                this.scrollLeft = scrollLeft + event.deltaY * 1.5;
                });
            });
        }
    };
</script>

<style lang="less" scoped>
    @import './HelloWorld.less';
    @import '@/assets/media/media-css.less';
</style>
